import BaseInfo from '@/model/modules/BaseInfo'

export default class FromUserInfo extends BaseInfo {
  name: string = ''
  fromName: string = ''
  fromTel: string = ''
  fromAdd: string = ''
  fromState: string = ''
  fromCountry: string = ''
  fromProvince: string = ''
  fromCity: string = ''
  fromPostcode: string = ''
}
